import { Box, InputAdornment, Modal, TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import CancelPresentationIconButton from "../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../common/components/Buttons/CommonButton";
import RadioField from "../../common/components/FormFields/RadioField";
import SalesDetailsListTable from "./SalesDetailsListTable";
import SalesListTable from "./SalesListTable";
import {
  getSalesItemDetails,
  getSalesViewBiilsList,
  getSearchedPatients,
} from "./Services";
import SearchDropdown from "../../common/components/FormFields/searchDropdownOld";
import InputField from "../../common/components/FormFields/InputField";
import SearchIcon from "@mui/icons-material/Search";

const patientTypeObj = [
  { id: 3, value: 3, label: "All", name: "All" },
  { id: 0, value: 0, label: "OPD", name: "OPD" },
  { id: 1, value: 1, label: "IPD", name: "IPD" },
  { id: 2, value: 2, label: "Counter", name: "COUNTER" },
];
const defaultValues = {
  patientType: 3,
  searchPatient: "",
  mrNo: "",
};

function SalesModal(props) {
  const loggedUser = JSON.parse(localStorage.getItem("userInfo"));
  const { watch, getValues, setValue, control, register, reset } = useForm({
    defaultValues: defaultValues,
  });
  const [selectedFromDate, setSelectedFromDate] = React.useState(new Date());
  const [selectedToDate, setSelectedToDate] = React.useState(new Date());
  const [counterSalesList, setCounterSalesList] = React.useState({});
  const [selectedSalesId, setSelectedSalesId] = React.useState(null);
  const [itemDetails, setItemDetails] = React.useState({});
  const [itemsToReturn, setItemsToReturn] = React.useState([]);
  const [patients, setPatients] = React.useState([]);

  let getPatientType = watch("patientType");
  let searchPatientWatch = watch("searchPatient");
  let getMrNo = watch("mrNo");

  React.useEffect(() => {
    if (counterSalesList?.result?.length > 0) {
      let filtered = counterSalesList?.result?.filter(
        (sale) => sale?.SalesId === selectedSalesId
      );

      if (filtered?.[0]?.employeeId > 0) {
        props.setEmployeeId(filtered[0]?.employeeId);
      } else {
        props?.setEmployeeId(null);
      }
    }
  }, [selectedSalesId]);

  const populateReturnTable = () => {
    console.log("getMrNo", getMrNo);
    setItemDetails({ statusCode: 300, result: [] });
    let obj = {
      fromDate: selectedFromDate,
      opdIpd: Number(getPatientType),
      storeId: loggedUser?.storeId,
      toDate: selectedToDate,
      menuId: props?.menuId,
      privilege: props?.privilege,
      salesId: searchPatientWatch !== "" ? searchPatientWatch : "",
      mrNo: getMrNo !== "" ? Number(getMrNo) : 0,
    };
    getSalesViewBiilsList(obj)
      .then((response) => response.data)
      .then((res) => {
        if (res.result.length > 0) {
          setCounterSalesList(res);
        } else {
          setItemDetails({ statusCode: 300, result: [] });
          setCounterSalesList({ statusCode: 300, result: [] });
        }
      });
  };

  React.useEffect(() => {
    if (props.open) {
      populateReturnTable();
    }
  }, [props.open]);

  React.useEffect(() => {
    if (selectedSalesId !== null) {
      if (props.component === "return") {
        props.setRetSalesId(selectedSalesId);
      }

      getSalesItemDetails(selectedSalesId)
        .then((response) => response.data)
        .then((res) => {
          let resultData = res.result;

          let modified = [];

          if (resultData?.length > 0) {
            for (let item of resultData) {
              item.isSelected = false;
              modified.push(item);
            }
            let modifiedData = {
              statusCode: 200,
              result: modified,
            };
            setItemDetails(modifiedData);
          }
        });
    } else {
      setItemDetails({ result: [] });
    }
  }, [selectedSalesId]);

  const handleSearchPatient = (searchString) => {
    if (searchString !== "") {
      let searchObject = {
        opdIpd: Number(getPatientType),
        storeId: loggedUser?.storeId,
        fromDate: selectedFromDate,
        toDate: selectedToDate,
        searchString: searchString,
      };

      getSearchedPatients(searchObject)
        .then((response) => response.data)
        .then((res) => {
          setPatients(res?.result);
        })
        .catch((err) => err);
    }
  };

  return (
    <>
      <>
        <Modal
          open={props.open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          disableAutoFocus
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              height: "90%",
              bgcolor: "background.paper",
              p: 2,
              overflow: "scroll",
            }}
            className="w-[90%] xl:w-[95%]"
          >
            <div>
              <div className="flex items-center justify-between">
                <div>
                  {props.component === "return" ? (
                    <span className="font-semibold text-lg ">Sales Return</span>
                  ) : (
                    <span className="font-semibold text-lg ">
                      Previous Bills :
                    </span>
                  )}
                </div>
                <div>
                  <CancelPresentationIconButton
                    className="text-red-500 cursor-pointer"
                    onClick={() => {
                      setCounterSalesList({ statusCode: 200, result: [] });
                      setItemDetails({ statusCode: 200, result: [] });
                      setSelectedFromDate(new Date());
                      setSelectedToDate(new Date());
                      reset(defaultValues);
                      props.close();
                      props.setResetCount(props.resetCount + 1);
                      setSelectedSalesId(null);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-3">
                <fieldset className="flex gap-1 justify-center items-center bg-white border rounded px-2 -mt-2 lg:col-span-2">
                  <legend className="font-semibold text-xs px-2">
                    Patient Type &nbsp; :
                  </legend>
                  <div className="-my-2">
                    <RadioField
                      className="whitespace-nowrap"
                      control={control}
                      name="patientType"
                      dataArray={patientTypeObj}
                    />
                  </div>
                </fieldset>
                <div className="flex space-x-2 lg:col-span-2">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      // disablePast
                      label="From Date"
                      value={selectedFromDate}
                      name="fromDate"
                      onChange={(newValue) => {
                        setSelectedFromDate(newValue);
                      }}
                      inputFormat="dd/MM/yyyy"
                      renderInput={(params) => (
                        <TextField
                          className="bg-white"
                          fullWidth
                          name="fromDate"
                          size="small"
                          defaultValue=""
                          {...params}
                          sx={{
                            svg: { color: "#0B83A5" },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      disableFuture
                      label="To Date"
                      value={selectedToDate}
                      inputFormat="dd/MM/yyyy"
                      onChange={(newValue) => {
                        setSelectedToDate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          className="bg-white"
                          name="toDate"
                          fullWidth
                          size="small"
                          {...params}
                          sx={{
                            svg: { color: "#0B83A5" },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                <Controller
                  name="mrNo"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="MRNo"
                      type="number"
                      onChange={(e) => {
                        field.onChange(e);
                        if (e?.target?.value) {
                          setValue("searchPatient", "");
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                {/* <SearchDropdown
                    control={control}
                    name={"searchPatient"}
                    label={"Search By Patient Name"}
                    placeholder={"Search By Patient Name"}
                    handleInputChange={handleSearchPatient}
                    searchIcon={true}
                    isClearable={true}
                    dataArray={patients}
                    inputRef={{
                      ...register("searchPatient", {
                        onChange: (e) => {
                          if (e?.target?.value !== null) {
                            setValue("mrNo", null);
                          } else {
                            populateReturnTable();
                          }
                        },
                      }),
                    }}
                  /> */}
                <Controller
                  name="searchPatient"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      size="small"
                      label="Search Patient Name"
                      onChange={(e) => {
                        field.onChange(e); // Important: keep react-hook-form in sync
                        if (e?.target?.value) {
                          setValue("mrNo", "");
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                <div className="col-span-2 xl:col-span-1 flex justify-end lg:justify-start">
                  <CommonButton
                    type="button"
                    className="h-9 cursor-pointer w-14 px-2 rounded-md bg-customBlue text-white "
                    searchIcon={true}
                    onClick={populateReturnTable}
                  />
                </div>
              </div>
              {counterSalesList.statusCode === 200 &&
              counterSalesList.result?.length > 0 ? (
                <div>
                  <SalesListTable
                    data={counterSalesList}
                    setSelectedSalesId={setSelectedSalesId}
                    setPatientName={props.setPatientName}
                    setPatientInfo={props.setPatientInfo}
                    component={props.component}
                    openPrintWindow={props.openPrintWindow}
                    setSelectedPatient={props.setSelectedPatient}
                  />
                </div>
              ) : (
                <div className="flex justify-center items-center border rounded font-semibold h-72 mt-2">
                  No Records Found..!!
                </div>
              )}

              {itemDetails.statusCode === 200 &&
              itemDetails?.result?.length > 0 &&
              counterSalesList.result?.length > 0 ? (
                <div>
                  <SalesDetailsListTable
                    component={props.component}
                    data={itemDetails}
                    setItemDetails={setItemDetails}
                    itemsToReturn={itemsToReturn}
                    setItemsToReturn={setItemsToReturn}
                    returnItems={props.returnItems}
                    setReturnItems={props.setReturnItems}
                    setCounterSalesList={setCounterSalesList}
                    setSelectedSalesId={setItemDetails}
                    setSelectedFromDate={setSelectedFromDate}
                    setSelectedToDate={setSelectedToDate}
                    close={props.close}
                    populateReturnTable={populateReturnTable}
                    resetCount={props.resetCount}
                    setResetCount={props.setResetCount}
                  />
                </div>
              ) : (
                ""
                // <div className="flex justify-center font-semibold text-gray-400 my-5">Please Select a Record..!!</div>
              )}
            </div>
          </Box>
        </Modal>
      </>
    </>
  );
}

export default SalesModal;
